import type { JSX } from "react";
import { cn } from "./cn";

export interface DividerProps {
  /** Extra className (margins only) */
  readonly className?: string;
}

/**
 * A horizontal divider line.
 */
export function Divider({ className }: DividerProps): JSX.Element {
  return <div className={cn("border-t border-edge", className)} />;
}
